import { slugToTitle } from "@/lib/slug";

/**
 * SEO-safe fallback shell for the venue details route.
 * Used when the loader returns null (transient backend failure)
 * and by VenueDetailsErrorBoundary.
 */
export function VenueDetailsFallback({ slug }: { slug: string }) {
  const title = slugToTitle(slug);
  return (
    // The testid is the SSR smoke test's discriminator: the shell's slug-derived <h1>
    // is otherwise indistinguishable from the real venue UI's.
    <main
      id="main"
      data-testid="venue-details-fallback"
      className="max-w-[1440px] mx-auto p-8 bg-bg-brand-secondary-default"
    >
      <h1 className="title-m-bold mb-4">{title}</h1>
      <p className="body-m-regular text-fg-neutral-subtle">
        Accessibility information for {title}. Loading venue details...
      </p>
    </main>
  );
}
